import { useMutation, useQueryClient } from '@tanstack/react-query';

import { useApiClient } from '../ApiClientProvider';
import { queryKeys } from '../keys';
import type { MeResponse } from '../types/settings';

type CompleteOnboardingResponse = { completed: boolean };

export function useCompleteOnboarding() {
  const api = useApiClient();
  const qc = useQueryClient();
  return useMutation<CompleteOnboardingResponse, Error, void>({
    mutationFn: () => api.post('/admin/onboarding/complete'),
    onSuccess: () => {
      // Patch the cache synchronously so the OnboardingGate doesn't bounce the
      // merchant back to /setup on the next navigation before the refetch lands.
      qc.setQueryData<MeResponse>(queryKeys.me, (prev) =>
        prev
          ? { ...prev, onboarding: { ...prev.onboarding, completed: true, required: false } }
          : prev,
      );
      void qc.invalidateQueries({ queryKey: queryKeys.me });
    },
  });
}
